
const authentication = require('react-azure-adb2c2').default;
export function update(values: any) {
    const token = authentication.getAccessToken();
    const url = `https://homestationapi.azurewebsites.net/api/RentContractMonies/` + values.id

    return fetch(url, {
        method: 'put',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        //.then(payload => ({ payload }))
        .catch(error => ({ error }));


}


/**
 *
 *
 * @export
 * 
 * @param {*} values
 * rent_contract_id     
 * 
 * @returns
 * rent_contract_monies json配列
 * 
 */
export function insert(values: any) {

    const token = authentication.getAccessToken();
    const url = `https://homestationapi.azurewebsites.net/api/RentContractMonies/`

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        //.then(payload => ({ payload }))
        .catch(error => ({ error }));
}


/**
 *
 *
 * @export
 * 
 * @param {*} values
 * rent_contract_id     
 * 
 * @returns
 * rent_contract_monies json配列
 * 
 */
export function get_money_list(values: any) {
    // if(values.rent_contract_id!>0){return;}

    const token = authentication.getAccessToken();
    const url = `https://homestationapi.azurewebsites.net/api/RentContractMonies/` + values.rent_contract_id;
    //    alert(url)
    // const search = values ? values : {};
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(search),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));
}


export function getdetail(values: any) {

    const token = authentication.getAccessToken();
    const url = `https://homestationapi.azurewebsites.net/api/RentContractMonies/` + values.responseId;

    return fetch(url, {
        headers: { 'Authorization': 'Bearer ' + token }
    })
        .then(res => res.json())
        //.then(payload => ({ payload }))
        .catch(error => ({ error }));
}

